import { Formik } from "formik";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { variants } from "../../constant/Variants";
import { adminId, LoginReducer } from "../slice";
import { toast } from "react-toastify";
import Loader from "./../../component/Loader";
import Routers from "../../routes/Router";
import { setAuthData } from "../auth/authSlice";
import { setTeacherId, setModules } from "../../app/globalStore";
// import { subdomainSelector } from "../subdomainSlice"; // COMMENTED: For subdomain-based login (if reverting back)



const variant = {
  hidden: { opacity: 0, x: "100vw" },
  visible: {
    opacity: 1,
    x: 0,
    transtion: { duration: 1, type: "tween", ease: "easeIn" },
  },
};

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loding, setLoding] = useState(false);
  // const subdomain = useSelector(subdomainSelector); // COMMENTED: For subdomain-based login (if reverting back)

  return (
    <section className='' >
      {/* COMMENTED: Original subdomain-based UI logic - kept for future reference if client wants to revert
      <section className={subdomain ? '' : 'bg-image'} >
      */}
      <div className="container-fluid">
        <div className="row align-items-center">
          {/* CURRENT: Super Admin Login UI (no subdomain) */}
          <div className="col-sm-12 col-md-5 col-lg-5 order-2 order-md-1 d-flex flex-column d-none">
            <div className="logo-bg d-none d-md-block">
              <div className="mt-2" >
                <img
                  src="assets/images/activity.png"
                  className="img-fluid lft-img"
                  alt="logo"
                />
              </div>
            </div>
          </div>
          
          
          {/* { !subdomain ? (
            <div className="col-sm-12 col-md-5 col-lg-5 order-2 order-md-1 d-flex flex-column">
              <div className="logo-bg d-none d-md-block">
                <div className="mt-2" >
                  <img
                    src="assets/images/activity.png"
                    className="img-fluid lft-img"
                    alt="logo"
                  />
                </div>
              </div>
            </div>
          ) : ( */}
            <div
              className="col-sm-12 col-md-5 d-flex flex-column justify-content-between align-items-center text-center text-md-start order-2 order-md-1"
              style={{
                backgroundColor: '#F8FCFF',
                height: '100vh',
                padding: '40px 24px',
                borderRadius: 0,
                position: 'relative',
              }}
            >
              <div className="flex-grow-1 d-flex flex-column justify-content-center align-items-center w-100 mb-4">
                <div className="text-center mb-4 d-flex align-items-center justify-content-center">
                  <img
                    src="assets/images/activity.png"
                    alt="logo"
                    style={{
                      width: 150,
                      height: 100,
                      borderRadius: '0%',
                      marginRight: 16,
                    }}
                  />
                  {/* <h2 style={{
                    fontWeight: 700,
                    fontSize: 28,
                    color: '#333',
                    marginBottom: 15,
                    lineHeight: 1.2
                  }}>
                    Welcome to <br /> BookInClass
                  </h2> */}
                </div>
                <div className="text-center">
                  <h3 style={{
                    fontWeight: 600,
                    fontSize: 24,
                    color: '#333',
                    marginBottom: '20px'
                  }}>
                    Welcome to BookInClass
                  </h3>
                  <div style={{
                    position: 'relative',
                    maxWidth: '400px',
                    width: '100%'
                  }}>
                    <img
                      src="assets/images/image.png"
                      alt="illustration"
                      className="img-fluid"
                      style={{
                        maxWidth: '100%',
                        height: 'auto'
                      }}
                    />
                  </div>
                </div>
                <div className="w-100 text-center d-flex justify-content-center align-items-center mt-4">
                  <p style={{
                    fontSize: 18,
                    color: '#333',
                    lineHeight: 1.6,
                    margin: 0,
                    maxWidth: '400px'
                  }}>
                    The smarter way to manage <br />
                    classes, bookings, memberships, <br />
                    events, and payments — all <br />
                    in one place.
                  </p>
                </div>
              </div>
            </div>
          {/*  )} */}
          
          
          {/* <div className="col-sm-12 col-md-7 col-lg-7 order-1 order-md-2 flex-grow-1 d-flex flex-column justify-content-center align-items-center" style={{backgroundColor: 'transparent', height:'100vh'}}> */}
          
          <div className="col-sm-12 col-md-7 col-lg-7 order-1 order-md-2 flex-grow-1 d-flex flex-column justify-content-center align-items-center" style={{backgroundColor: '#b3e6f9', height:'100vh'}}>
          
            <div className="form-bg">
              <Formik
                initialValues={{
                  email: "",
                  password: "",
                  toggle: false,
                }}
                validationSchema={Yup.object({
                  email: Yup.string()
                    .email("Kindly enter a valid email.")
                    .required("Required"),
                  password: Yup.string().required("Required"),
                })}
                onSubmit={(values, action) => {
                  setLoding(true);
                  dispatch(
                    LoginReducer({
                      email: values.email?.trim()?.toLowerCase(),
                      password: values.password
                      // COMMENTED: url_id: subdomain // For subdomain-based login (if reverting back)
                    })
                  ).then((res) => {
                    setLoding(false);
                    if (res?.payload?.code === 1) {
                      const authData = res?.payload?.data;
                      
                      // CURRENT: Store auth data in Redux instead of localStorage (secure)
                      dispatch(setAuthData(authData));
                      
                      // Keep token in localStorage for API calls
                      localStorage.setItem("token", authData.token);
                      
                      // Set global store values for backward compatibility
                      setTeacherId(authData.teacher_id);
                      setModules(authData.modules);
                      dispatch(adminId(authData.adminId));
                      console.log('authData--------',authData);
                      // Store companies in localStorage only for Super Admins
                      if (authData.user_type?.toLowerCase() === "super_admin" && authData.companies) {
                        localStorage.setItem("companies", JSON.stringify(authData.companies));
                      } else {
                        // Clear companies for non-super admins
                        localStorage.removeItem("companies");
                      }
                      
                      /* COMMENTED: Original localStorage approach (if reverting back)
                      await localStorage.setItem("id", res?.payload?.data?.adminId);
                      await localStorage.setItem("teacher_id", res?.payload?.data?.teacher_id);
                      setTeacherId(res?.payload?.data?.teacher_id);
                      setModules(res?.payload?.data?.modules);
                      await localStorage.setItem("companies", JSON.stringify(res?.payload?.data?.companies));
                      await localStorage.setItem("booking_fee", res?.payload?.data?.booking_fee);
                      dispatch(adminId(res?.payload?.data?.adminId));
                      */
                      
                      // Navigate based on user type and permissions
                      if (
                        authData.admin_type?.toLowerCase() === "super admin"
                      ) {
                        navigate("/dashboard", { replace: true });
                      } else {
                        let data = authData.modules;
                        for (const key in data) {
                          if (Object.hasOwnProperty.call(data, key)) {
                            const slicedKey = key.replaceAll("_", "-");
                            const element = data[key];
                            if (element === true) {
                              const firstMatchedRole = Routers.find((item) => {
                                return (
                                  item.hidden === false &&
                                  item.path
                                    .replaceAll("/", "")
                                    .replaceAll("-", " ")
                                    ?.includes(slicedKey)
                                );
                              });
                              console.log(firstMatchedRole);
                              navigate(firstMatchedRole.path, {
                                replace: true,
                              });
                              break;
                            }
                          }
                        }
                      }
                      toast.success(res?.payload?.message);
                    } else {
                      toast.error(res?.payload?.message, {  autoClose: false,  closeButton: true});
                    }
                  });
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  getFieldProps,
                  setFieldValue,
                  setFormikState,
                }) => (
                  <form className="form-style" onSubmit={handleSubmit}>
                    <div className="row">
                      <div
                        variants={variants.card}
                        className="col-sm-12 col-md-12 text-center mb-5"
                      >
                      <h2 className="mdl-ttl">Login</h2>
                      </div>
                      <div
                        variants={variants.card}
                        className="col-sm-12 col-md-12 mb-4"
                      >
                        <div className="form-group">
                          <div className="input-container">
                            <input
                              type="email"
                              className="form-control pl-5"
                              placeholder="Email Address"
                              name="email"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.email}
                              {...getFieldProps("email")}
                            />
                            <img
                              src="assets/images/Email-Address.png"
                              className="input-img"
                              alt=""
                            />
                          </div>
                          {errors.email && touched.email && (
                            <div className="text-red">{errors.email}</div>
                          )}
                        </div>
                      </div>
                      <div
                        variants={variants.card}
                        className="col-sm-12 col-md-12 mb-4"
                      >
                        <div className="form-group">
                          <div className="input-container">
                            <input
                              type={values.toggle ? "text" : "password"}
                              className="form-control pl-5"
                              placeholder="Password"
                              name="password"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.password}
                              {...getFieldProps("password")}
                            />
                            <img
                              src="assets/images/password.png"
                              className="input-img"
                              alt=""
                            />
                            <span
                              className={
                                values.toggle
                                  ? "pass-hide field-icon "
                                  : "pass-view field-icon "
                              }
                              onClick={(e) => {
                                e.preventDefault();
                                setFormikState((prevState) => {
                                  return {
                                    ...prevState,
                                    values: {
                                      ...prevState.values,
                                      toggle: !prevState.values.toggle,
                                    },
                                  };
                                });
                              }}
                            ></span>
                          </div>
                          {errors.password && touched.password && (
                            <div className="text-red">{errors.password}</div>
                          )}
                        </div>
                      </div>

                      {/* CURRENT: Super Admin Login Button Layout */}
                      <div
                        variants={variants.card}
                        className="col-sm-12 col-md-12 text-center mb-4"
                      >
                        <Link to="/forget-password" className="forgot-pass">
                          Forgot Password?
                        </Link>
                      </div>
                      <div
                        variants={variants.card}
                        className="col-sm-12 col-md-12 text-center"
                      >
                        <button type="submit" className="btn btn-save" disabled={loding}>
                          {loding ? <Loader /> : "Log In"}
                        </button>
                      </div>
                      
                      {/* COMMENTED: Original subdomain-based button layout (if reverting back)
                      {subdomain ? (
                        <>
                          <div
                            variants={variants.card}
                            className="col-sm-12 col-md-12 text-center"
                          >
                            <button type="submit" className="btn btn-save" style={{ width: "100%" }} disabled={loding}>
                              {loding ? <Loader /> : "Log In"}
                            </button>
                          </div>
                          <div
                            variants={variants.card}
                            className="col-sm-12 text-center col-md-12 mt-4" style={{ padding: "10px", fontWeight:'bolder' }}
                          >
                            <Link to="/forget-password">
                              Forgot Password?
                            </Link>
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            variants={variants.card}
                            className="col-sm-12 col-md-12 text-center mb-4"
                          >
                            <Link to="/forget-password" className="forgot-pass">
                              Forgot Password?
                            </Link>
                          </div>
                          <div
                            variants={variants.card}
                            className="col-sm-12 col-md-12 text-center"
                          >
                            <button type="submit" className="btn btn-save" disabled={loding}>
                              {loding ? <Loader /> : "Log In"}
                            </button>
                          </div>
                        </>
                      )}
                      */}
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
